var exports = {
  "Octicon": "Octicon__4KPTP2",
  "Octicon_1": "Octicon_1__pIudkn",
  "Box": "Box__1sFYwB",
  "FormControl": "FormControl__rfCak1",
  "Box_1": "Box_1__ZmG5V0",
  "Heading": "Heading__TehMMJ",
  "Box_2": "Box_2__xSONXy",
  "Container": "Container__A6V-wG",
  "Octicon_2": "Octicon_2__s9FtvR",
  "Box_4": "Box_4__cTiv6O",
  "Box_5": "Box_5__HrOiVD",
  "GitHubAvatar": "GitHubAvatar__qn4Qtr",
  "Text": "Text__kwztU6",
  "Text_1": "Text_1__O3V5VA",
  "isInputActive": "isInputActive__q4C-jF",
  "suggestionItem": "suggestionItem__hCq5Lw",
  "collabSuggestionItem": "collabSuggestionItem___eWSrA",
  "BorderlessTextInput": "BorderlessTextInput__ZtOdXe",
};

__webpack_require__.r(module.exports = exports);
